import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';

interface CalculatorCardProps {
  title: string;
  description: string;
  onClick: () => void;
}

const CalculatorCard: React.FC<CalculatorCardProps> = ({ title, description, onClick }) => {
  return (
    <Card 
      sx={{
        width: '100%',
        minHeight: { xs: '300px', sm: '250px' },  
        maxHeight: { xs: 'none', sm: '250px' },   
        borderRadius: '10px',
        backgroundColor: '#fff',
        boxShadow: '0 10px 30px rgba(0, 0, 0, 0.1)',
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out',
        cursor: 'pointer',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '&:hover': {
          transform: 'scale(1.05)',
          boxShadow: '0 15px 40px rgba(0, 0, 0, 0.2)',
        }
      }}
      onClick={onClick}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography 
          variant="h5" 
          component="div" 
          sx={{ 
            marginBottom: '20px', 
            fontSize: { xs: '1.1rem', sm: '1.25rem' },
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          color="textSecondary"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: { xs: 5, sm: 3 }, 
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'normal',
            marginBottom: '8px',
            flexGrow: 1,
            fontSize: { xs: '0.75rem', sm: '0.875rem' },  
          }}
        >
          {description}
        </Typography>
      </CardContent>
      <Box display="flex" justifyContent="center" padding="16px">
        <Button 
          variant="contained" 
          color="primary" 
          sx={{
            fontSize: { xs: '0.75rem', sm: '0.875rem' },
            marginBottom: '30px', 
          }}
          onClick={onClick}
        >
          Calculate
        </Button>
      </Box>
    </Card>
  );
};

export default CalculatorCard;
